module.exports = __webpack_public_path__ + "static/media/logo-ssn1.c7a92e23.png";